module.exports = __webpack_public_path__ + "static/media/bcom-economics_LR.2df4d767.jpg";